export default __webpack_public_path__ + "static/media/ChloeBeisheim.d058f5ea.JPG";